<template lang="pug">
  .details-view
    //- .d-flex.align-items-center.justify-content-center.cursor-pointer
    span.nav-arrow.toggle-btn.d-flex.align-items-center.justify-content-center(
      :class="{ closed: activeView !== 'details-list-wrapper' }"
      v-if="isMobile" @click="toggleView"
    )
      img(:src="require('@assets/_shared/double-arrow.svg')")
    .details-list-wrapper(:class="{ hidden: isMobile && activeView !== 'details-list-wrapper' }")
      .actions
        SearchWithButtons(
          v-model="search"
          :showSearch="true"
          :clientSide="true"
        )
      .details-list
        el-row
          el-col(:span='24')
            SoilSensorsList(
              :transmitters="transmitters"
            )
      .pagination
        Pagination(
          :view="'transmitters'"
          :fieldId="selectedFieldId"
          :search="search"
          @viewData="handleGetTransmitters"
          @handleTableLoading="handlePaginationLoading"
        )
    .details-chart-wrapper(:class="{ hidden: isMobile && activeView !== 'details-chart-wrapper' }")
      br
      .filters
        .fields-info-box(v-if="Array.isArray(fieldsInfoSettings) && fieldsInfoSettings.length > 0")
          .description
            | {{ $t('sensors.fields_info_settings.actions.description.optimal_ranges', { field: fieldName }) }}
          .fields-summary
            span(
              v-for="(item, i) in fieldsInfoSettings"
              :key="item.id"
              class="field-tag"
            )
              | {{ item.info_type.toUpperCase() }}: {{ item.range1s }} - {{ item.range1e }} {{ item.info_type_unit }}
        .datetime-picker
          FilterDatePicker(
            v-model="dateRange"
            :resetSignal="resetKey"
            @onChange="handleChange"
          )
        .button
          el-button.el-icon-refresh-left.mr-2.cursor-pointer(
            style="font-size: 35px; margin-right: 0px;"
            :class="{disabled: generatePausedForSeconds}"
            :loading="generatePausedForSeconds"
            @click="reloadData()")
      SoilSensorsCharts(
        :sensor="soilSensor"
        :chartData="sensorInfos"
        :chartType="chartType"
        :fieldsInfoSettings="fieldsInfoSettings"
        :datetime="dateRange"
      )
</template>

<script>
import { filterUtils } from "@utils/filterUtils";
import SearchWithButtons from "@components/_shared/SearchWithButtons";
import SoilSensorsList from "@components/client/details/SoilSensorsList";
import Pagination from "@components/_shared/Pagination";
import SoilSensorsCharts from "@components/client/details/SoilSensorsCharts";
import FilterDatePicker from "@components/_shared/FilterDatePicker";
import { mapActions, mapState } from "vuex";
import { general } from "@src/services/dynamicViews/general";

export default {
  name: "DeatilsView",
  mixins: [filterUtils, general],

  components: {
    SearchWithButtons,
    SoilSensorsList,
    Pagination,
    SoilSensorsCharts,
    FilterDatePicker,
  },

  data() {
    return {
      loading: false,
      selectedFieldId: "",
      search: "",
      chartType: null,
      sensorInfos: null,
      generatePausedForSeconds: false,
      reload: false,
      dateRange: [],
      transmitters: [],
      soilSensors: [],
      resetKey: null,
      fieldsInfoSettings: [],
      fieldName: "",
      activeView: 'details-list-wrapper',
      isMobile: false,
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("soilSensor", ["soilSensor"]),
    ...mapState("field", ["selectedField", "selectedFieldInfoSettings"]),

  },

  created(){
    if(this.selectedField && this.selectedField != "all"){
      this.selectedFieldId = this.selectedField.id.toString();
    }      
    else {
      this.selectedFieldId = "all";
    }
  },

  mounted() {
    this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
  },

  watch: {
    selectedField(){
      if(this.selectedField && this.selectedField != "all"){
        this.selectedFieldId = this.selectedField.id.toString();
      }
      else {
        this.selectedFieldId = "all";
      }
    },

    async soilSensor() {
      await this.handleGetField();
      await this.handleChange(this.dateRange);
    },

    async reload(val) {
      if (val) {
        this.handleLoading(true);
        await this.handleChange(this.dateRange);
        this.handleLoading(false);
      }
    }
  },

  methods: {
    ...mapActions('sensorInfo', ['getSoilSensorInfo']),
    ...mapActions("field", ["getFieldInfoSettings"]),
    ...mapActions("transmitter", ["getTransmitter"]),

    checkMobile() {
      this.isMobile = window.innerWidth <= 1400;
    },
    toggleView() {
      this.activeView = this.activeView === 'details-chart-wrapper' ? 'details-list-wrapper' : 'details-chart-wrapper';
    },

    handleGetTransmitters(data) {
      this.transmitters = data;
    },

    handleGetSoilSensors(data) {
      this.soilSensors = data;
    },

    handleLoading(loading) {
      this.loading = loading;
      if(!loading) {
        setTimeout(() => this.generatePausedForSeconds = loading, 2000);
      }else {      
        this.generatePausedForSeconds = loading;
      }
      this.reload = false;
    },

    reloadData(){
      this.resetKey = Date.now();
      this.reload = true;
    },

    handlePaginationLoading(loading) {
      this.loading = loading
    },

    async handleChange(values) {
      let computedParams;
      if(this.soilSensor) {
        if (values && values.length > 0) {
          let dateRangeComputed = {
            start_date: values[0],
            end_date: values[1],
          };
          this.dateRange = [dateRangeComputed.start_date, dateRangeComputed.end_date];
          computedParams = `?by_soil_sensor_id=${this.soilSensor.id}&by_date_range[start_date]=${dateRangeComputed.start_date}&by_date_range[end_date]=${dateRangeComputed.end_date}`;

          const response = await this.getSoilSensorInfo(computedParams);
          this.sensorInfos = response;
        } 
        else {
          this.sensorInfos = [];
        }
      }
    },

    async handleGetField(){
      const transmitterResponse = await this.getTransmitter(this.soilSensor.sensor_transmitter.id);

      if( transmitterResponse.data && transmitterResponse.data.field) {
        let fieldId = transmitterResponse.data.field.id;
        this.fieldName = transmitterResponse.data.field_name;
        const response = await this.getFieldInfoSettings(`?by_field_id=${fieldId}`);

        this.fieldsInfoSettings = response.data.map((item) => ({
          id: item.id,
          info_type: item.info_type || '',
          info_type_unit: item.info_type_unit || '',
          range1s: parseFloat(item.range1s) || 0,
          range1e: parseFloat(item.range1e) || 0,
          range1color: item.range1color || '',
          range2s: parseFloat(item.range2s) || 0,
          range2e: parseFloat(item.range2e) || 0,
          range2color: item.range2color || '',
          range3s: parseFloat(item.range3s) || 0,
          range3e: parseFloat(item.range3e) || 0,
          range3color: item.range3color || ''
        }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@variables";

.nav-arrow {
  position: absolute;
  top: 25%;
  left: 1%;
  font-size: 24px;
  user-select: none;
  height: 40px;
  width: 40px;
  z-index: 1;
  background-image: linear-gradient($gradient-start, $gradient-end);
  border-radius: 50%;
  transition: transform 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.closed {
    transform: rotate(180deg);
  }
  img {
    z-index: 9999;
    max-width: 60%;
    max-height: 60%;
    pointer-events: none; // makes sure img doesn't "steal" the click
    display: block;
  }
}

.container {
  .hidden {
    display: none !important;
  }

  .toggle-btn {
    display: none;
  }

  @media (max-width: 1400px) {
    flex-direction: column;

    .details-list-wrapper,
    .details-chart-wrapper {
      margin-left: 5%;
      
    }

    .details-list-wrapper {
      width: 83%;
      display: grid;
      grid-template-rows: auto;
      grid-template-areas: 
      "header"
      "main"
      "footer";

      .actions {
        grid-area: header;

      }
      .details-list {
        grid-area: main;
        // margin: auto;
      }
      .pagination{
        grid-area: footer;
        // margin: auto;
      }
    }

    .details-chart-wrapper {
      width: 89%;
      .filters {
        display: grid;
        grid-template-rows: auto;
        grid-template-areas: 
        "header"
        "main"
        "footer";

        .fields-info-box {
          grid-area: header;

          .description {
            
            margin: auto;
          }
        
          .fields-summary {
            width: 200px;
            margin: auto;
        
            .field-tag {
              font-size: 12px;
            }
          }
        }
        .datetime-picker {
          grid-area: main;
          margin: auto;
        }
        .button {
          grid-area: footer;
          margin: auto;
        }
      }
    }

    .toggle-btn {
      display: block;
    }
  }
}
</style>
